import $ from 'jquery';

class Header {
    constructor() {

    }

    smoothScrollToWithAnchor() {
        // Select all links with hashes
        $('a[href*="#"]')
        // Remove links that don't actually link to anything
            .click(function (event) {
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: (target.offset().top),
                        }, {
                            duration: 200,
                            specialEasing: {
                                width: 'linear',
                                height: 'easeOutBounce',
                            },
                            complete: function () {

                            },
                        })
                    }
                }
            });
    }

    sticky() {
        $(window).scroll(function () {
            var headerClass = '.header';
            var navClass = '.header > .header-nav';
            var navHeight = $(navClass).outerHeight();

            if ($(window).scrollTop() >= 1) {
                $(navClass).addClass('header--fixed');
                $(headerClass).css('height', navHeight + 'px');
            }
            else {
                $(navClass).removeClass('header--fixed');
                $(headerClass).css('height', 'auto');
            }
        });
    }

    hideSpecNavOnScroll() {
        if ($('#header__main-navigation-sticky').length > 0) {
            var prevScrollpos = window.pageYOffset;
            var specScrollInterval = null

            window.onscroll = function () {
                var currentScrollPos = window.pageYOffset;
                clearInterval(specScrollInterval);
                specScrollInterval = setTimeout(function () {
                    if (prevScrollpos > currentScrollPos && !$('body').hasClass('hideSpecNavOnScroll--stop')) {
                        if ($(window).width() <= 414) {
                            document.getElementById('header__main-navigation-sticky').style.height = '89px';
                        } else {
                            document.getElementById('header__main-navigation-sticky').style.height = '60px';
                        }
                    } else {
                        document.getElementById('header__main-navigation-sticky').style.height = '0';
                    }
                    prevScrollpos = currentScrollPos;
                }, 100);
            }
        }
    }

    loadEvents() {
        this.smoothScrollToWithAnchor();
        // this.sticky();
        // this.hideSpecNavOnScroll();
    }
}

export default Header;



// WEBPACK FOOTER //
// ./scripts/util/header.js